module.exports = __webpack_public_path__ + "img/Hearder-01-m.8481f873.png";